import React from 'react';
import { useIntl } from 'umi';
import { Input, Bubble, Button } from 'tea-component';
import { TYPES, typesTextMap } from '../../_config/constant';
import useSelector from '../../hooks/useSelector';
import { NO_DATE } from '@op/constants';

const Selector = ({
  defaultValue,
  defaultType,
  onConfirm,
  onCancel,
  close,
}: any) => {
  const { formatMessage } = useIntl();
  const {
    type,
    rangeDate,
    errorMessage,
    handleConfirm,
    handleCancel,
    handleTypeChange,
    handleRangeDateChange,
  } = useSelector({
    defaultValue,
    defaultType,
    onConfirm,
    onCancel,
    close,
  });

  return (
    <div className="range-day-month-selector-dropdown">
      <div className="range-day-month-selector-tab-type">
        {TYPES?.map((item, index) => (
          <span
            className={`
              range-day-month-selector-tab-type-item
              ${item.value === type ? 'range-day-month-selector-active' : ''}
            `}
            onClick={() => handleTypeChange(item.value)}
            key={index}
          >
            {formatMessage({ id: item.name })}
          </span>
        ))}
      </div>
      <div className="range-day-month-selector-range-input">
        {formatMessage({ id: 'Release' })}
        <Bubble
          closeOnScroll
          visible={errorMessage[0]?.length > 0 ? true : false}
          overlayClassName="range-day-month-selector-bubble"
          placement="top"
          content={formatMessage({ id: errorMessage[0] || NO_DATE.EMPTY })}
          error
        >
          <Input
            value={rangeDate[0]}
            onChange={(value) => handleRangeDateChange([value, rangeDate[1]])}
            max={9999}
            min={1}
            maxLength={4}
          />
        </Bubble>
        <i>-</i>
        <Bubble
          closeOnScroll
          visible={errorMessage[1]?.length > 0 ? true : false}
          overlayClassName="range-day-month-selector-bubble"
          placement="top"
          content={formatMessage({ id: errorMessage[1] || NO_DATE.EMPTY })}
          error
        >
          <Input
            value={rangeDate[1]}
            onChange={(value) => handleRangeDateChange([rangeDate[0], value])}
            max={9999}
            min={1}
            maxLength={4}
          />
        </Bubble>
        {formatMessage({ id: typesTextMap[type] })}
      </div>
      <div className="range-day-month-selector-footer">
        <Button
          disabled={errorMessage?.some((item) => item)}
          // className="range-day-month-selector-footer-confirm"
          type="primary"
          onClick={handleConfirm}
          style={{ marginRight: 10 }}
        >
          {formatMessage({ id: 'Confirm' })}
        </Button>
        <Button
          className="range-day-month-selector-footer-cancel"
          onClick={handleCancel}
        >
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </div>
    </div>
  );
};

export default Selector;
